import React, { useEffect, useState } from "react";
import { Avatar, Button, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate, useLocation } from "react-router-dom";
import routes from "../../../constants/routes";
import { Form } from "react-bootstrap";
import {
  getToken,
  removeToken,
  getUserData,
  timeZones,
  localTimeZone,
  getTimeZone,
  removeLocalTimeZone,
} from "../../../common";
import useStyles from "./dashboardMenu.style";
import momentTimezone from "moment-timezone";
import useAuctionCreateAccess, {
  AUCTION_CREATE_DENIED_MESSAGE,
} from "../../../hooks/useAuctionCreateAccess";

function DashboardMenu() {
  const yy = window.location.href;

  const classes = useStyles();
  const navigate = useNavigate();
  const userData = getUserData() ?? {};
  const timeZonesList = timeZones();
  const [menutype, SetMenuType] = useState(localStorage.getItem("menutype"));
  const [currentTimeZones, SetCurrentTimeZone] = useState(
    localStorage.getItem("currentTimeZone")
      ? localStorage.getItem("currentTimeZone")
      : localTimeZone
  );

  const location = useLocation();
  const {
    isLoading: isAuctionAccessLoading,
    canCreateAuction,
  } = useAuctionCreateAccess();

  const [active, SetActive] = useState("");
  // useEffect(() => {
  //   const value = localStorage.getItem('menutype')
  //  SetMenuType(value)
  // }, [])

  const colorChange = [
    { name: "Dashboard", navigate: routes.dashboard },
    {
      name: "Auctions",
      navigate: routes.dashboardAuction,
    },
    userData.role != "BUYER" && { name: "Bidders", navigate: routes.dashBuyer },
    userData.role === "ADMIN" && {
      name: "Auctioneers",
      navigate: routes.dashSeller,
    },

    (userData.role === "ADMIN" || userData.role === "SELLER") && {
      name: "Live Auctions",
      navigate: routes.liveAuctions,
    },
    { name: "Profile", navigate: routes.profile },
    userData.role === "ADMIN" && {
      name: "API Configuration",
      navigate: routes.apiConfiguration,
    },
    userData.role === "ADMIN" && {
      name: "Activity Logs",
      navigate: routes.activityLogs,
    },
  ];
  return (
    <div>
      <div className={classes.dashboards}>
        <div className="row">
          <div className="col-md-12">
            <Box className={classes.menu}>
              <div className="row dashMenu align-items-center justify-content-start">
                {colorChange
                  .filter((x) => x !== false)
                  .map((d, i) => {
                    return (
                      <div className="col-lg mobMenu" key={i}>
                        <Typography
                          className={classes.menuHeading}
                          onClick={() => {
                            navigate(d.navigate);
                            SetActive(i);
                          }}
                          style={{
                            color: yy.includes(d.navigate) ? "#2D55EB" : "#000",
                          }}
                          sx={{ fontSize: "13px" }}
                        >
                          {d.name}
                        </Typography>
                      </div>
                    );
                  })}
                {userData.role === "SELLER" && !isAuctionAccessLoading && (
                  <div className="col-lg mobMenu">
                    <div className="">
                      {/* mobSideMenu */}
                      <Box
                        className="Buttons mobTopBar"
                        sx={{ marginRight: "2em" }}
                      >
                        {/* sellers without auction creation rights are stopped
                        here instead of on submit of the auction form */}
                        <Tooltip
                          title={
                            canCreateAuction ? "" : AUCTION_CREATE_DENIED_MESSAGE
                          }
                        >
                          <span>
                            <Button
                              disabled={!canCreateAuction}
                              onClick={() => {
                                navigate(routes.createvent);
                              }}
                              className="btn btn-group view ml-3"
                            >
                              Create Auction
                            </Button>
                          </span>
                        </Tooltip>
                      </Box>
                    </div>
                  </div>
                )}
                {location.pathname === "/dashboard" && (
                  <div className="col-lg mobMenu">
                    {/* mobSideMenu */}
                    <div className="Buttons mobTopBar">
                      <Box
                        sx={{ marginRight: "2em", sm: { marginRight: "0" } }}
                        className="mobTopBar"
                      >
                        <Form.Select
                          style={{ width: "10em", fontSize: "13px" }}
                          aria-label="Default select example"
                          className={classes.select}
                          name="eventType"
                          onChange={(event) => {
                            SetCurrentTimeZone(event.target.value);

                            localStorage.setItem(
                              "currentTimeZone",
                              event.target.value
                            );
                            removeLocalTimeZone();
                          }}
                          value={currentTimeZones}
                        >
                          <option>Select Zones</option>
                          {timeZonesList.map((zones, index) => {
                            return <option value={zones}>{zones}</option>;
                          })}
                        </Form.Select>
                      </Box>
                    </div>
                  </div>
                )}
                <div className="col-lg mobMenu">
                  {/* mobSideMenu */}
                  {userData.role === "BOTH" && (
                    <div className="Buttons mobTopBar">
                      <Form.Select
                        aria-label="Default select example"
                        className={classes.select}
                        name="eventType"
                        onChange={(event) => {
                          SetMenuType(event.target.value);
                          localStorage.setItem("menutype", event.target.value);
                        }}
                        value={menutype}
                      >
                        <option value="SELLER">Seller</option>
                        <option value="BUYER">Buyer</option>
                      </Form.Select>
                    </div>
                  )}
                  {userData.role === "SELLER" && (
                    <Box
                      className="Buttons mobTopBar"
                      sx={{ marginRight: "2em" }}
                    >
                      <Button className="btn btn-group view ml-3">
                        SELLER
                      </Button>
                    </Box>
                  )}
                  {userData.role === "BUYER" && (
                    <Box
                      className="Buttons mobTopBar"
                      sx={{ marginRight: "2em" }}
                    >
                      <Button className="btn btn-group view ml-3">BUYER</Button>
                    </Box>
                  )}
                  {userData.role === "ADMIN" && (
                    <Box
                      className="Buttons mobTopBar"
                      sx={{ marginRight: "2em", fontSize: "13px" }}
                    >
                      <Button
                        className="btn btn-group view ml-3"
                        style={{ fontSize: "13px !important" }}
                        sx={{ fontSize: "13px !important" }}
                      >
                        ADMIN
                      </Button>
                    </Box>
                  )}
                </div>
              </div>
            </Box>
          </div>
          {/* <div className="col-md-3 m-auto"></div> */}
        </div>
      </div>
    </div>
  );
}

export default DashboardMenu;
